export default __webpack_public_path__ + "static/media/download-icon.ae03b287.svg";